import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';

import { batch, useDispatch } from 'react-redux';
import { TOOLBAR_ELEMENT_ID } from 'const';
import { setLastEditedLayoutId } from 'containers/App/actions';
import { updateProjectState } from 'containers/Project/actions';
import styles from './styles.module.scss';

type Props = PropsWithChildren<{
  className?: string;
  layoutId?: string;
  title?: string;
  renderViaPortal?: boolean;
  dataTestId?: string;
}>;

const BaseToolbar: React.FunctionComponent<Props> = (props) => {
  const dispatch = useDispatch();
  const {
    children,
    className = '',
    layoutId,
    title = '',
    renderViaPortal = true,
    dataTestId = 'baseToolbar',
  } = props;
  const toolbarClassName = classNames(styles.EditorToolbar, className);

  React.useEffect(() => {
    dispatch(updateProjectState({ isOpenToolbar: true }));

    return () => {
      batch(() => {
        dispatch(updateProjectState({ isOpenToolbar: false }));
        dispatch(setLastEditedLayoutId(layoutId));
      });
    };
  }, []);

  const toolbar = (
    <div className={toolbarClassName} data-testid={dataTestId}>
      {title && <div className={styles.title} data-testid={`${dataTestId}-title`}>{title}</div>}
      {children}
    </div>
  );

  return renderViaPortal ? ReactDOM.createPortal(toolbar, document.getElementById(TOOLBAR_ELEMENT_ID)) : toolbar;
};

export default BaseToolbar;
